'use client'

import { useFormStatus } from 'react-dom'

export default function SubmitButton({
  children,
  className,
  style,
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}) {
  const { pending } = useFormStatus()
  return (
    <button type="submit" disabled={pending} className={className} style={style}>
      {pending ? 'Redirecting…' : children}
    </button>
  )
}
